import { Component, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';

import { NavService } from 'src/app/shared/services/nav.service';
import { LayoutService } from 'src/app/shared/services/layout.service';
import { Role } from 'src/app/shared/model/user-role.enum';
import { AuthService } from 'src/app/shared/services/auth.service';
import { PortalId } from 'src/app/shared/model/portal-id.enum';
import { WebConfigService } from '../../services/web-config/web-config.service';
import { MyAccountComponent } from './elements/my-account/my-account.component';
import { FeatherIconsComponent } from '../feather-icons/feather-icons.component';
import { RouterLink } from '@angular/router';
import { Flavour } from '../../services/web-config/web-config.helper';
import { AuthStateService } from '../../services/auth/auth-state.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [MyAccountComponent, FeatherIconsComponent, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class HeaderComponent implements OnInit {
  private webconfig = inject(WebConfigService);
  #authState = inject(AuthStateService);
  public logo = signal(null);

  /** The header's look, by element. `collapsed-root:` is the wrapper while the sidebar is the icon-only rail. */
  protected readonly ui = {
    header:
      'fixed top-0 z-8 ml-[280px] w-[calc(100%-280px)] max-w-[100vw] bg-white shadow-[0_0_20px_rgba(89,102,122,0.1)] transition-all duration-500 ease-css ' +
      'collapsed-root:ml-[90px] collapsed-root:w-[calc(100%-90px)] max-lg:ml-0! max-lg:w-[calc(100%-0px)]!',
    wrapper:
      'relative m-0 flex w-full flex-wrap items-center px-[30px] py-[22px] max-lg:py-3 max-sm:px-[15px]! max-sm:py-3!',
    toggleWrapper: 'max-lg:mr-0 max-lg:flex',
    toggle:
      'hidden cursor-pointer btn-bare text-start text-(--sidebar-toggle-icon-color) [&_svg]:w-5 [&_svg]:align-middle max-lg:static max-lg:mr-[15px] max-lg:block ' +
      'max-lg:border-r max-lg:border-[#ddd] max-lg:pr-[15px] max-sm:mr-2 max-sm:ml-0 max-sm:pr-2 max-sm:pl-0 max-sm:[&_svg]:w-[18px]',
    spacer:
      'relative w-full max-w-full grow basis-0 pr-[15px] max-[1366px]:pr-0 max-md:static lg:max-xl:max-w-[26%] lg:max-xl:flex-[0_0_26%]',
    navRight:
      'relative float-right w-full max-w-[66.666667%] flex-[0_0_66.666667%] justify-end p-0 max-xl:static lg:max-xl:max-w-[71.66667%] lg:max-xl:flex-[0_0_71.66667%]',
    menus: 'flex items-center justify-end',
    profile: 'group/dd relative mr-[5px] inline-block cursor-pointer p-0 max-sm:mr-px',
  } as const;

  isDemoMode = signal(false);

  public readonly roleEnum: typeof Role = Role;

  public demoMode = true;
  public userRole: Role = null;

  constructor(
    private authService: AuthService,
    public layout: LayoutService,
    public navServices: NavService,
  ) {}

  ngOnInit() {
    this.logo.set(this.webconfig.assets.logo);
    this.isDemoMode.set(
      this.webconfig.orgId === Flavour.Go &&
        this.webconfig.portalId === PortalId.Merchant &&
        this.#authState.merchant()?.demoMode &&
        this.#authState.user()?.role !== Role.Admin,
    );
  }

  sidebarToggle() {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
  }
}
